<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <PlaceForm
      v-if="!isLoading"
      :placeData="placeData"
      :imageSrc="imageSrc"
      :submitName="$t('add')"
      v-on:addOrUpdatePlace="addPlace"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import DEFAULT_IMG_CLIENT from "@/assets/images/places.svg";
import PlaceForm from "@/components/places/places/PlaceForm.vue";
import Place from "@/models/places/places/Place";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "PlaceAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    PlaceForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      imageSrc: DEFAULT_IMG_CLIENT,
      placeData: new Place(),
    };
  },
  methods: {
    async addPlace() {
      this.isLoading = true;
      try {
        let response = await this.placeData.addOrUpdatePlace(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.placeData.setInitialValue();
          this.placeData.placePhone1WithCC = "";
          this.placeData.placePhone2WithCC = "";
          this.placeData.placePhone3WithCC = "";
          this.placeData.placePhone4WithCC = "";
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {},
};
</script>

<style scoped lang="scss"></style>
